import React, { useState } from 'react';

import eventIconGol from '../../../images/event_gol.png'
import eventIconAutogol from '../../../images/event_autogol.png'
import eventIconYellowCard from '../../../images/event_yellow_card.png'
import eventIconRedCard from '../../../images/event_red_card.png'
import eventIconVallaInvicta from '../../../images/event_valla_invicta.png'
import ModalConfirm from '../../useful/ModalConfirm';

const MatchesListFormSummary = (props) => {

    const { teamAUid, players, eventMap } = props;
    const [confirmModal, setConfirmModal] = useState({ show: false, title: '', message: '', event: {} });

    const eventList = Object.values(eventMap);

    const removeEvent = () => {
        const event = confirmModal.event;
        setConfirmModal({ show: false, title: '', message: '', event: {} })
        props.removeEvent(event);
    }

    const showConfirmModal = (event) => {
        setConfirmModal({
            show: true,
            title: 'Eliminar Evento', message: 'Está seguro de eliminar este evento?',
            event: event
        });
    }

    eventList.sort((a, b) => b.minute - a.minute)
    const eventListComponent = eventList.map((event, index) => {
        const flexRowClass = event.teamUid === teamAUid ? " flex-row" : " flex-row-reverse"
        let eventIcon = null
        let minuteText = event.minute + "'";
        switch (event.event) {
            case 'gol': eventIcon = eventIconGol; break;
            case 'auto_gol': eventIcon = eventIconAutogol; break;
            case 'yellow_card': eventIcon = eventIconYellowCard; break;
            case 'red_card': eventIcon = eventIconRedCard; break;
            case 'valla_invicta':
                eventIcon = eventIconVallaInvicta;
                minuteText = "";
                break;
            default: eventIcon = null;
        }

        const player = players.find(item => item.uid == event.playerUid)

        if (player) {
            return (
                <div key={index} onClick={() => showConfirmModal(event)} className="bg-hover" data-toggle="tooltip" data-placement="top" title="Eliminar">
                    <div className={"align-items-center p-1 d-flex " + flexRowClass}>
                        <span className="font-weight-bold">{minuteText}</span>
                        <img className="ml-1 mr-1" src={eventIcon} height="18" alt="" />
                        <span className="text-right">{(player && player.name) || '-'}</span>
                    </div>
                    <div className={"row m-0 d-flex " + flexRowClass}>
                        <div className="col-7 p-0 border-bottom" />
                    </div>
                </div>
            );
        } else {
            return <></>
        }
    });

    return (
        <>
            {eventListComponent}

            <ModalConfirm
                data={confirmModal}
                onClose={() => setConfirmModal({ show: false, title: '', message: '', event: {} })}
                onConfirm={removeEvent}
            />
        </>
    )
}

export default React.memo(MatchesListFormSummary);
